export const aciFilterAlt = {
    iconName: 'filter-alt',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M.75 2.25a1.5 1.5 0 011.5-1.5h19.5a1.5 1.5 0 011.5 1.5v19.5a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5V2.25z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M15.75 11.265v-6M15.75 18.765v-3',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M18 13.515a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M8.25 9.765v9',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M10.5 7.515a2.25 2.25 0 10-4.5 0 2.25 2.25 0 004.5 0v0z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
